// Redacts PAN, email, dates and long digit runs. Server error copy often echoes
// back what the user submitted, and none of that may reach analytics.
const PII_PATTERNS: Array<[RegExp, string]> = [
  [/\b[A-Z]{5}[0-9]{4}[A-Z]\b/gi, "[pan]"],
  [/[\w.+-]+@[\w-]+\.[\w.-]+/g, "[email]"],
  [/\b\d{1,4}[-/]\d{1,2}[-/]\d{1,4}\b/g, "[date]"],
  [/\b\d{6,}\b/g, "[number]"],
];

const MAX_MESSAGE_LENGTH = 200;

export function scrubPii(text: any): string {
  if (text === undefined || text === null) return "";
  let safe = typeof text === "string" ? text : String(text);
  PII_PATTERNS.forEach(([pattern, replacement]) => {
    safe = safe.replace(pattern, replacement);
  });
  return safe.replace(/\s+/g, " ").trim().slice(0, MAX_MESSAGE_LENGTH);
}
